import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';

@Component({
  selector: 'app-financial-report-page',
  templateUrl: './financial-report-page.component.html',
  styleUrl: './financial-report-page.component.scss'
})
export class FinancialReportPageComponent {
  deviceType;

  constructor(
    private router: Router,
    private localStorageService: LocalStorageService,
  ) {
    this.deviceType = localStorageService.getItem('deviceType');
    if (this.deviceType !== 'mobile') {
      this.router.navigate(['financial/report'], { replaceUrl: true });
    }
  }
}
